import React from 'react';
import { useNavigate } from 'react-router-dom';

const Download = () => {
    const navigate = useNavigate();

    return (
        <div className="container-fluid py-4">
            {/* Header */}
            <div className="row mb-4">
                <div className="col-12">
                    <div className="card shadow-sm border-0">
                        <div className="card-body py-4">
                            <div className="row align-items-center">
                                <div className="col-md-6">
                                    <h2 className="h4 mb-1 fw-bold text-dark">
                                        <i className="bi bi-cloud-download me-2 text-primary"></i>
                                        Download Center
                                    </h2>
                                    <p className="text-muted mb-0">
                                        Get the tools you need to power your system
                                    </p>
                                </div>
                                <div className="col-md-6 text-end">
                                    <button
                                        className="btn btn-outline-secondary"
                                        onClick={() => navigate('/dashboard')}
                                    >
                                        <i className="bi bi-arrow-left me-2"></i>
                                        Back to Dashboard
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Main Content */}
            <div className="row justify-content-center">
                <div className="col-md-8 col-lg-6">
                    <div className="card shadow-lg border-0 h-100">
                        <div className="card-header bg-primary text-white text-center py-4">
                            <i className="bi bi-cloud-arrow-down display-4"></i>
                            <h3 className="mt-3 fw-bold">Zkpull Utility</h3>
                        </div>
                        <div className="card-body p-5 text-center">
                            <h5 className="mb-4 text-muted">Bridge Your Data to the Cloud</h5>

                            <p className="lead mb-4">
                                Zip into the future! The <strong>Zkpull</strong> tool is the magical bridge between your physical biometric devices and the digital sky.
                            </p>

                            <p className="mb-5 text-secondary">
                                It effortlessly synchronizes your local attendance data, lifting it securely to the cloud.
                                Ensure your records are always real-time, accurate, and accessible from anywhere in the world.
                                Just install, configure, and let it fly!
                            </p>

                            <a
                                href="https://hrms.vrishab.in/downloads/Zkpull.zip"
                                className="btn btn-primary btn-lg px-5 py-3 rounded-pill shadow-sm hover-scale mb-3"
                            >
                                <i className="bi bi-download me-2"></i>
                                Download Zkpull.zip
                            </a>

                            <div className="mt-4">
                                <small className="text-muted">
                                    <i className="bi bi-shield-check me-1"></i>
                                    Secure Download • v1.0 • Windows Compatible
                                </small>
                            </div>

                            {/* Configuration Instructions */}
                            <div className="mt-5 p-4 bg-light rounded">
                                <h6 className="fw-bold mb-3">
                                    <i className="bi bi-info-circle me-2 text-primary"></i>
                                    Configuration Instructions
                                </h6>
                                <ol className="text-start text-muted small">
                                    <li className="mb-2">Download and extract Zkpull.zip to your desired location</li>
                                    <li className="mb-2">Extract Zkpull.zip and ensure config.json is placed in the same directory as Zkpull.exe</li>
                                    <li className="mb-2">Open config.json in a text editor and update the following:</li>
                                    <ul>
                                        <li><strong>company_id</strong>: Replace with your company ID provided by your solution provider</li>
                                        <li><strong>company_name</strong>: Your company/organization name</li>
                                        <li><strong>api_endpoint</strong>: Your HRMS API endpoint (if different from default)</li>
                                        <li><strong>device_ids</strong>: Add your biometric device IDs</li>
                                    </ul>
                                    <li>Save the file and run Zkpull.exe</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Quick Links / Footerish style */}
            <div className="row mt-5">
                <div className="col-12 text-center text-muted">
                    <p>
                        Need help installing? <span className="text-primary cursor-pointer" onClick={() => alert('Please contact support for installation guide.')}>View Documentation</span>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Download;
